import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ItemsRequestModel } from ".";
import { ISearchParam } from "../BaseApp";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { EmptyItemRequestModel } from "./ItemsRequestsApp";

interface IItemRequestsState {
    requests: ItemsRequestModel[],
    selectedRequests: ItemsRequestModel[],
    searchParams: ISearchParam[],
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search: string
}

const initialState: IItemRequestsState = {
    requests: [],
    selectedRequests: [],
    searchParams: [],
    search: "",
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const itemsRequestsSlice = createSlice({
    name: "itemsRequests",
    initialState,
    reducers: {
        updateAllItemsRequests: (state: IItemRequestsState, action: PayloadAction<ItemsRequestModel[]>) => {
            state.requests = action.payload
        },
        addNewItemsRequest: (state: IItemRequestsState, action: PayloadAction<ItemsRequestModel>) => {
            let requests = state.requests

            if (requests.filter(request => request.id === action.payload.id).length === 0){
                state.requests.push(action.payload)
            }

        },
        deleteItemsRequest: (state: IItemRequestsState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let requests = state.requests

            requests = requests.filter(request => request.id !== payload.id)

            state.requests = requests

        },
        updateItemsRequest: (state: IItemRequestsState, action: PayloadAction<ItemsRequestModel>) => {
            let requests = state.requests
            
            if (requests && requests.length > 0){
                requests.map((request) => {
                    if (request.id === action.payload.id){

                        const locationIndex = requests.findIndex(request => request.id === action.payload.id)
                        requests[locationIndex] = action.payload

                    }
                })
            }

            state.requests = requests

        },
        updateItemsRequestsLoadingStatus: (state: IItemRequestsState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateItemsRequestsPagination: (state: IItemRequestsState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateItemsRequestsSearch: (state: IItemRequestsState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        updateItemsRequestsSearchParams: (state: IItemRequestsState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
        setSelectedItemsRequests: (state: IItemRequestsState, action: PayloadAction<ItemsRequestModel[]>) => {
            state.selectedRequests = action.payload
        },
    }
})

/**
 * Return all requests
 */
export const useReturnAllItemRequests = () => useSelector((state: RootState) => state.itemsRequests.requests)

/**
 * Retrun single request
 */
export const useReturnSingleItemRequest = (id: number) => {
    const requests = useReturnAllItemRequests()

    let request: ItemsRequestModel = EmptyItemRequestModel

    if (requests.length > 0){
        requests.map((single) => {
            if (single.id === id){
                request = single
            }
        })
    }

    return request

}

/**
 * Return requests loading status
 */
export const useReturnItemsRequestsLoadingStatus = () => useSelector((state: RootState) => state.itemsRequests.loading)

/**
 * Return requests pagination
 */
export const useReturnItemsRequestsPagination = () => useSelector((state: RootState) => state.itemsRequests.pagination)

/**
 * Return requests search
 */
export const useReturnItemsRequestsSearch = () => useSelector((state: RootState) => state.itemsRequests.search)

/**
 * Return requests search params
 */
export const useReturnItemsRequestsSearchParams = () => useSelector((state: RootState) => state.itemsRequests.searchParams)

/**
 * Return Selected requests
 */
export const useReturnSelectedItemsRequests = () => useSelector((state: RootState) => state.itemsRequests.selectedRequests)

export const { updateAllItemsRequests, addNewItemsRequest, deleteItemsRequest, updateItemsRequest, updateItemsRequestsLoadingStatus, updateItemsRequestsPagination, updateItemsRequestsSearch, updateItemsRequestsSearchParams, setSelectedItemsRequests } = itemsRequestsSlice.actions
export default itemsRequestsSlice.reducer